import { render, staticRenderFns } from "./TheCourse.vue?vue&type=template&id=2be44dea&"
import script from "./TheCourse.vue?vue&type=script&lang=js&"
export * from "./TheCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports